import { render, staticRenderFns } from "./DisputeList.vue?vue&type=template&id=0b1ee180&scoped=true"
import script from "./DisputeList.vue?vue&type=script&lang=ts"
export * from "./DisputeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ee180",
  null
  
)

export default component.exports